import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';
import { FileUploadCancellationRequest } from 'app/types/fileProcessingService';

export interface CancelAETFileRequest {
  fileUploadId: string;
  cancellationRequest?: FileUploadCancellationRequest;
}

const useCancelAETFile = (options?: UseMutationOptions<void, Error, CancelAETFileRequest>) => {
  return useMutation<void, Error, CancelAETFileRequest>({
    mutationFn: async ({ fileUploadId, cancellationRequest = {} }) => {
      return FileProcessingApiHandler.cancelFileUpload(
        fileUploadId,
        cancellationRequest as Record<string, unknown>
      );
    },
    ...options,
  });
};

export default useCancelAETFile;
